// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__HGmG0","author":"Table_author__2se0i","authorImage":"Table_authorImage__OA6E5","unreadRow":"Table_unreadRow__3x9Ok"};